/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
//
export default new Vuex.Store({
  state: {
    loginOpen: false,
    site: null,
    authentication: '',
    personalInfo: '',
    afterLogin: null,
    simpleMsg: null,
    pendingRequest: null,
    completeRequest: null,
    mySelected: null,
    mySuccession: null,
    stopResume: '',
    short: 'N',
    searchInfo: {},
  },
  mutations: {
    putMySelected(state, list) {
      state.mySelected = list;
    },
    openLogin(state, afterLogin) {
      state.loginOpen = true;
      state.afterLogin = afterLogin;
    },
    closeLogin(state) {
      state.loginOpen = false;
    },
    setSite(state, value) {
      state.site = value;
    },
    setAuthentication(state, value) {
      state.authentication = value;
    },
    setPersonalInfo(state, value) {
      state.personalInfo = value;
    },
    setShort(state, value) {
      state.short = value;
    },
    simpleMsg(state, command) {
      state.simpleMsg = command;
    },
    pendingRequest(state, value) {
      state.pendingRequest = value;
    },
    completeRequest(state, value) {
      state.completeRequest = value;
    },
    putMySuccession(state, value) {
      state.mySuccession = value;
    },
    stopResume(state, value) {
      state.stopResume = value;
    },
    storeSearchInfo(state, pair) {
      state.searchInfo[pair.path] = pair.value;
    },
  },
  actions: {
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js